export default {
  fontFamily: ['"Poppins"', 'sans-serif', 'Roboto'].join(','),
}
